/**
 * Checks if a token has expired based on the ExpirationDateTimeUTC from the backend.
 * Note: The backend already applies a 30-second buffer to ExpirationDateTimeUTC,
 * so this function simply checks if we've passed that adjusted expiration time.
 * @param accessToken - The JWT access token whose presence is required before performing the expiration check
 * @param expirationDateTimeUTC - The expiration date in UTC format from the backend (already adjusted with buffer)
 * @returns true if the token has expired (or is about to, based on backend's buffer)
 */
export function isTokenExpired(
    accessToken: string | null,
    expirationDateTimeUTC: string | null
): boolean {
    if (!accessToken || !expirationDateTimeUTC) {
        return false;
    }

    try {
        const currentTime = new Date().getTime();
        const expirationTime = new Date(expirationDateTimeUTC).getTime();

        return currentTime >= expirationTime;
    } catch (error) {
        console.error('Error checking token expiration:', error);
        return false;
    }
}
